import React,{useState,useEffect,lazy} from 'react';
import axios from 'axios'
import {  Slider,Statistic,Tabs,Modal } from 'antd';
import { ArrowUpOutlined,MinusCircleFilled,ToolOutlined, ArrowDownOutlined,FileFilled,WalletFilled,SearchOutlined,FundViewOutlined,
   UserOutlined, AccountBookOutlined,CalculatorFilled,SwapOutlined,GroupOutlined,AccountBookFilled, DollarCircleOutlined,EditFilled,MessageFilled,DollarOutlined,CarFilled,LoadingOutlined,PlusCircleFilled } from '@ant-design/icons';
import moment from 'moment';
import { Line,Pie,Bar } from 'react-chartjs-2';
import {withGetScreen} from 'react-getscreen'
import { Tooltip,Popover,Table,Popconfirm,Input, Button,Collapse,Card,Avatar,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin } from 'antd';
import {
  Col,
  Row,
} from 'reactstrap';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
import * as serverconfig from '../serverconn'
import * as serversocketconfig from '../serversocketconfig'
import { MdShoppingCart } from 'react-icons/md';

import CurrencyFormat from 'react-currency-format';
import Highlighter from 'react-highlight-words';
import Websocket from 'react-websocket';
import { Link } from 'react-router-dom';
import ReconnectingWebSocket from 'reconnecting-websocket';
import { NavLink } from 'react-router-dom'
import * as primarycolor from '../primarycolor'
import ApplicationForm from '../components/ApplicationForm';
import Applications from './Applications';
import ApplicantActions from './ApplicantActions';
import Licences_Granted from './Licences_Granted';

var CryptoJS = require("crypto-js");

const { TextArea } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

const style = { background: '#0092ff', padding: '8px 0',borderRadius: '7px',justifyContent:'center', alignItems:'center',display: 'flex', };
const dateFormat = 'DD/MM/YYYY';
const yeardateFormat = 'YYYY';
const monthdateFormat = 'MM/YYYY';

const { Meta } = Card;
const { Panel } = Collapse;
const { TabPane } = Tabs;
const FormItem=Form.Item;
const { Option } = Select;

var token= ''
var bizuserid= ''

class Home_Tab extends React.Component {

  state = {
    applications:[],
    applicant_actions:[],
    licences: [],

  };
 
  componentDidMount(){
   this.comp_reloaded() 
  }


comp_reloaded=()=>{

  if(localStorage.getItem("api_token")){
     token= localStorage.getItem("api_token")
  }else{
     token= ''
  }

  if(localStorage.getItem("bizuserid")){
    bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
 }else{
    bizuserid= ''
 }

  axios.defaults.headers={
    "Content-Type":"application/json",
    Authorization:`Token ${token}`
  }

  axios.get(serverconfig.backendserverurl+`/api/applications/?applicant=${bizuserid}`)
  .then(res => {
      this.setState({
          applications:res.data
      })
  })


  axios.get(serverconfig.backendserverurl+`/api/applicant_actions/?applicant=${bizuserid}&status=${"Pending"}`)
  .then(res => {
      this.setState({
        applicant_actions:res.data
      })
      this.setState({datarequested:false})
  })


  axios.get(serverconfig.backendserverurl+`/api/licences/?licence_holder=${bizuserid}`)
  .then(res => {
      this.setState({
          licences:res.data
      })
      this.setState({datarequested:false})
  })



}



render() {
      return(
        <div className="animated fadeIn" style={{width:'100%'}}>  

        <Tabs
            defaultActiveKey="1"
            onChange={() => {}}
            tabPosition={'top'}
          >

          <TabPane tab="Application Form" key="1">
            <ApplicationForm />
          </TabPane>


          <TabPane tab={"Applications ("+this.state.applications.length+")"} key="2">
            <Applications />
         
          </TabPane>

          <TabPane tab={"Licences ("+this.state.licences.length+")"}   key="3">
            <Licences_Granted />
          </TabPane>

          <TabPane tab={"Pending Actions ("+this.state.applicant_actions.length+")"} key="4">
            {this.state.applicant_actions.length>0?
              <ApplicantActions applicant_actions={this.state.applicant_actions}  />
            :
            null
            }
          </TabPane>

          </Tabs>
        </div>
      )
}
}

export default Home_Tab; 
